import React, { useContext, useEffect } from "react";
import ApplicationContext from "../../../context/ApplicationContext";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { IReceipt } from "../../../types/IReceipt";
import { advancePayment, createOrder } from "../../../services/Service";
import { IReceiptData } from "../../../types/IReceiptData";
import loadingImage from "../../../images/loading.gif";
import { IAdvancePaymentModalProps } from "./IAdvancePaymentModalProps";

export const AdvancePaymentModal: React.FC<IAdvancePaymentModalProps> = (
  props: IAdvancePaymentModalProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  const [payValue, setPayValue] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(false);

  const buttonStyle = {
    width: "19vh",
    height: "10vh",
    fontSize: "3.5vh",
    fontWeight: "bolder",
    maxWidth: "100px",
    maxHeight: "100px",
    padding: 0,
  };

  function appendChar(value: string) {
    let v = payValue;
    v = v + value;
    setPayValue(v);
  }

  useEffect(() => {
    setError(false);
    setPayValue("");
  }, [props.show]);

  function deleteLastChar() {
    const v = payValue;
    const newValue = v.substring(0, v.length - 1);
    setPayValue(newValue);
  }

  const paymentScreen = () => (
    <>
      <>
        <div
          style={{
            width: "100%",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <div>
            <div>
              {error ? (
                <Alert key="danger" variant="danger">
                  Please correct the amount. If the error persist please contact
                  support
                </Alert>
              ) : (
                <></>
              )}
            </div>
            <table>
              <tr>
                <td
                  style={{
                    width: 150,
                    backgroundColor: "whitesmoke",
                    verticalAlign: "top",
                    padding: 10,
                  }}
                >
                  <div>
                    Peek:
                    <h1>
                      <div style={{ color: "green" }}>
                        £{props.table.peekPrice.toFixed(2)}
                      </div>
                    </h1>
                  </div>
                  <div>
                    Off Peek:
                    <h1>
                      <div style={{ color: "green" }}>
                        £{props.table.offPeekPrice.toFixed(2)}
                      </div>
                    </h1>
                  </div>
                </td>
                <td style={{ width: 5, backgroundColor: "white" }}></td>
                <td>
                  <table>
                    <tr>
                      <td colSpan={4} style={{ backgroundColor: "" }}>
                        <Form.Control
                          placeholder="£"
                          aria-label="£"
                          aria-describedby="basic-addon1"
                          style={{
                            fontSize: "25px",
                            width: "40vw",
                            maxWidth: "410px",
                          }}
                          value={"£" + payValue}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("7")}
                        >
                          7
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("8")}
                        >
                          8
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("9")}
                        >
                          9
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("5.00")}
                        >
                          £5
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("4")}
                        >
                          4
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("5")}
                        >
                          5
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("6")}
                        >
                          6
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("10.00")}
                        >
                          £10
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("1")}
                        >
                          1
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("2")}
                        >
                          2
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("3")}
                        >
                          3
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("20.00")}
                        >
                          £20
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar("0")}
                        >
                          0
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => appendChar(".")}
                        >
                          .
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => deleteLastChar()}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            fill="currentColor"
                            className="bi bi-backspace"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.83 5.146a.5.5 0 0 0 0 .708L7.975 8l-2.147 2.146a.5.5 0 0 0 .707.708l2.147-2.147 2.146 2.147a.5.5 0 0 0 .707-.708L9.39 8l2.146-2.146a.5.5 0 0 0-.707-.708L8.683 7.293 6.536 5.146a.5.5 0 0 0-.707 0z" />
                            <path d="M13.683 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7.08a2 2 0 0 1-1.519-.698L.241 8.65a1 1 0 0 1 0-1.302L5.084 1.7A2 2 0 0 1 6.603 1zm-7.08 1a1 1 0 0 0-.76.35L1 8l4.844 5.65a1 1 0 0 0 .759.35h7.08a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                          </svg>
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          style={buttonStyle}
                          onClick={() => setPayValue("50.00")}
                        >
                          £50.00
                        </Button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </>
    </>
  );

  const customerModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Advance Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>{paymentScreen()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <div>
              <Button
                variant="info"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: 20,
                }}
                onClick={() => setPayValue("")}
              >
                Clear
              </Button>
            </div>
            <div>
              <Button
                variant="secondary"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: 20,
                }}
                onClick={() => props.close()}
              >
                Close
              </Button>
            </div>

            <Button
              variant="success"
              style={{
                width: 300,
                height: 50,
                fontSize: 20,
              }}
              onClick={() => addVancePayment()}
            >
              Add advance Payment
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  async function addVancePayment() {
    const enteredValue = payValue;
    const value = parseFloat(enteredValue);

    if (isNaN(value)) {
      return;
    }

    const isSaved = await advancePayment(
      props.table.uuid,
      context.AuthenticatedUser.getToken(),
      enteredValue
    );

    if (!isSaved) {
      setError(true);
      return;
    }

    props.close();
  }

  return (
    <>
      <>{customerModal()}</>
    </>
  );
};
